import React, { useState } from 'react';

import { Modal, BoldText, Text, Spacer, Background } from './styles';

import LockersImg from '../../../../../../assets/images/returnMethod.png';
import useConfigsStore from '../../../../store/configsStore';
import { ButtonPrimary } from '../../../../../../shared/components';

export default function DevolutionInstructions() {
  const [show, setShow] = useState(true);
  const integrationStatus = useConfigsStore((state) => state.integrationStatus);
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );

  return show ? (
    <Background>
      <Modal
        fontFamily={devolutionPageConfigs?.fontFamily}
        color={devolutionPageConfigs?.fontColor}
        backgroundColor={devolutionPageConfigs?.secondaryColor}
      >
        {integrationStatus?.correios ? (
          <>
            <Spacer height="10px" />
            <BoldText>Escolha sua forma de devolução</BoldText>
            <Spacer height="10px" />
            <img src={LockersImg} alt="Lockers" width={240} />
            <Spacer />
            <Text>
              Selecione o método de devolução desejado na barra lateral
              (clicando na seta a esquerda)
            </Text>
            <Spacer height="8px" />
            <Text>
              <strong>CliqueRetire:</strong> selecione o locker no mapa e
              finalize o pedido.
            </Text>
            <Spacer height="8px" />
            <Text>
              <strong>Correios:</strong> apenas finalize o pedido.
            </Text>
          </>
        ) : (
          <>
            <Spacer height="10px" />
            <BoldText>Escolha o locker para devolução!</BoldText>
            <Spacer height="10px" />
            <img src={LockersImg} alt="Lockers" width={240} />
            <Spacer />
            <Text>
              Selecione o locker mais próximo e finalize sua devolução!
            </Text>
          </>
        )}
        <Spacer height="15px" />
        <ButtonPrimary.Normal
          label="Vamos lá!"
          color={devolutionPageConfigs?.primaryColor}
          onClick={() => setShow(false)}
        />
      </Modal>
    </Background>
  ) : null;
}
